<template>
  <vxe-table
    border
    :scroll-x="{enabled: false}"
    :data="CalculatedData"
    :row-class-name="ConnectClassName"
    :max-height="MaxTableHeight"
    @cell-dblclick="ClickModifyResult"
    :auto-resize="true"
    v-loading="loading">
    <vxe-colgroup title="Player Information" align="center" fixed="left">
      <vxe-column 
        field="Connect" 
        title="Connect State" 
        align="center"  
        width="120">
        <template #default="scope">
          <el-tag
            :type="scope.row.Connect ? 'success' : 'danger'"
            disable-transitions>
              {{ scope.row.Connect ? 'Connected' : 'Disconnected' }}
          </el-tag>
        </template>
      </vxe-column>
      <vxe-column field="ID" title="Index" align="center" width="90"  sortable></vxe-column>
      <vxe-column field="Name" title="Name" align="center" width="120" ></vxe-column>
      <vxe-column 
        title="Rank" 
        align="center" 
        width="80"
        field="Rank"
        sortable>
      </vxe-column>
      <vxe-column 
        title="Big" 
        align="center" 
        width="80"
        field="BigScore">
      </vxe-column>
      <vxe-column 
        title="Small" 
        align="center" 
        width="80"
        field="SmallScore">
      </vxe-column>
    </vxe-colgroup>
    
    <!-- <vxe-colgroup title="Game Content" align="center">
      <vxe-colgroup
        v-if="Page.currentPage!=0"
        align="center"
        :title="'Round '+Page.currentPage"> -->
        <vxe-column
          v-if="MaxRoundNum!=0"
          title="Opponents Index"
          align="center"
          width="95">
          <template #default="scope">
            <div
              v-for="(oppo, idx) in scope.row.Rounds[Page.currentPage-1].Opponents"
              :key="idx">
              {{ oppo.ID }}
            </div>
          </template>
        </vxe-column>
        <vxe-column
          v-if="MaxRoundNum!=0"
          title="Opponents"
          align="center"
          width="120">
          <template #default="scope">
            <div
              v-for="(oppo, idx) in scope.row.Rounds[Page.currentPage-1].Opponents"
              :key="idx">
              {{ oppo.Name }}
            </div>
          </template>
        </vxe-column>
        <vxe-colgroup
          align="center"
          v-for="gameIndex in Array(MaxGameNum(Page.currentPage-1)).keys()"
          :key="'Game_'+gameIndex"
          :title="'Game '+(gameIndex+1)">
          <vxe-column
          title="Order"
          align="center"
          width="80">
            <template #default="scope">
              {{ scope.row.Rounds[Page.currentPage-1].Games[gameIndex].Order }}
            </template>
          </vxe-column>
          <vxe-column
          v-if="showResult"
          title="Result"
          align="center"
          width="80"
          :class-name="'Result_'+(Page.currentPage-1)+'_'+gameIndex">
            <template #default="scope">
              <el-tag
                :type="ResultClassName(scope.row.Rounds[Page.currentPage-1].Games[gameIndex].Result)"
                disable-transitions
                effect="dark">
                {{ scope.row.Rounds[Page.currentPage-1].Games[gameIndex].Result }}
              </el-tag>
            </template>
          </vxe-column>
          <vxe-column
          title="Score"
          align="center"
          width="80"
          :class-name="'Score_'+(Page.currentPage-1)+'_'+gameIndex">
            <template #default="scope">
              {{ scope.row.Rounds[Page.currentPage-1].Games[gameIndex].Score }}
            </template>
          </vxe-column>
        </vxe-colgroup>
        <vxe-column
          v-if="MaxRoundNum!=0" 
          title="Sum"
          align="center"
          width="80">
          <template #default="scope">
            {{ scope.row.Rounds[Page.currentPage-1].Sum }}
          </template>
        </vxe-column>
      <!-- </vxe-colgroup>
    </vxe-colgroup> -->
    
  </vxe-table>
  <el-pagination
  v-if="MaxRoundNum!=0"
  layout="prev, pager, next" 
  :page-count="MaxRoundNum"
  v-model:current-page="Page.currentPage">
  </el-pagination >
</template>

<style>
  .el-table .disconnect-row {
    background: #FFE8E8;
  }
  /* .vxe-table--render-default.border--full .vxe-header--column{
    background-image: linear-gradient(#e8eaec,#e8eaec),linear-gradient(#e8eaec,#e8eaec);
    background-position: 100% 0,100% 99%;
  }
  [class*="vxe-header--column"] {
    background-image: linear-gradient(#e8eaec,#e8eaec),linear-gradient(#e8eaec,#e8eaec);
    background-repeat: no-repeat;
    background-size: 1px 100%,100% 1px;
    background-position: 100% 0,100% 99%;
  } */
</style>

<script>
export default {
  name: 'LayoutContent',
  props: {
    loading: Boolean,
    showResult: Boolean,
    tableData : Object,
    ModifyResult: Function,
    rank: Array,
  },
  data() {
    return {
      Data: [
        {
          Rank: 1
        },{
          Rank: 2
        },
      ],
      Page:{
        currentPage: 1,
      }
    }
  },
  computed: {
    syncRank:{
      get(){
        return this.rank;
      },
      set(val){
        this.$emit('update:rank',val)
      }
    },
    MaxRoundNum(){
      let maxLength = 0;
      for(let i = 0; i < this.tableData.length; i++){
        if(Object.prototype.hasOwnProperty.call(this.tableData[i], 'Rounds')){
          maxLength = Math.max(maxLength, this.tableData[i].Rounds.length);
        }
      }
      return maxLength;
    },
    CalculatedData(){
      let newTableData = JSON.parse(JSON.stringify(this.tableData));
      
      // push Games
      for(let i = 0; i < newTableData.length; i++){
        if(Object.prototype.hasOwnProperty.call(newTableData[i], 'Rounds')){
          for(let j = 0; j < newTableData[i].Rounds.length; j++){
            if(!Object.prototype.hasOwnProperty.call(newTableData[i].Rounds[j], 'Games')){
              newTableData[i].Rounds[j].push({Games: []});
            }
            let maxGameLength = this.MaxGameNum(j);
            for(let k = newTableData[i].Rounds[j].Games.length; k < maxGameLength; k++){
              newTableData[i].Rounds[j].Games.push({
                Order: 0,
                Result: null,
                Score: 0,
              });
            }
          }
        }
      }

      // score
      let bigScoreArray = [];
      let smallScoreArray = [];
      for(let i = 0; i < newTableData.length; i++){
        newTableData[i].BigScore = this.BigScore(i);
        newTableData[i].SmallScore = this.SmallScore(i);
        bigScoreArray.push(newTableData[i].BigScore);
        smallScoreArray.push(newTableData[i].SmallScore);
      }

      // rank
      let scoreArray = [];
      let biggestSmallScore = Math.max.apply(Math, smallScoreArray);
      const base = biggestSmallScore + 1;
      for(let i = 0; i < newTableData.length; i++){
        scoreArray.push(bigScoreArray[i] * base + smallScoreArray[i]);
      }
      const rankArray = this.Rank(scoreArray);
      for(let i = 0; i < newTableData.length; i++){
        newTableData[i].Rank = rankArray[i];
      }

      // sum
      for(let i = 0; i < newTableData.length; i++){
        for(let j = 0; j < newTableData[i].Rounds.length; j++){
          let sum = 0
          for(let k = 0; k < newTableData[i].Rounds[j].Games.length; k++){
            sum += newTableData[i].Rounds[j].Games[k].Score;
          }
          newTableData[i].Rounds[j].Sum = sum;
        }
      }
      return newTableData;
    },
    MaxTableHeight(){
      return window.innerHeight - window.innerHeight * 0.2;
    },
  },
  methods: {
    MaxRound(){
      let maxLength = 0;
      for(let i = 0; i < this.tableData.length; i++){
        if(Object.prototype.hasOwnProperty.call(this.tableData[i], 'Rounds')){
          maxLength = Math.max(maxLength, this.tableData[i].Rounds.length);
        }
      }
      return maxLength;
    },
    MaxGameNum(roundIndex){
      let maxLength = 0;
      for(let i = 0; i < this.tableData.length; i++){
        if(Object.prototype.hasOwnProperty.call(this.tableData[i], 'Rounds')){
          if(this.tableData[i].Rounds.length > roundIndex){
            if(Object.prototype.hasOwnProperty.call(this.tableData[i].Rounds[roundIndex], 'Games')){
              maxLength = Math.max(maxLength, this.tableData[i].Rounds[roundIndex].Games.length);
            }
          }
        }
      }
      return maxLength;
    },
    ListFormatter(row, col, cv) {
      //console.log(row);
      //console.log(col);
      //console.log(cv);
      //console.log(col.rawColumnKey);
      let columnType = col.rawColumnKey.split('_')[0];
      let roundIndex = parseInt(col.rawColumnKey.split('_')[1]);
      let gameIndex = (col.rawColumnKey.split('_').length > 2 ? 
        parseInt(col.rawColumnKey.split('_')[2]) : -1);
      if(columnType === 'Order'){
        if(roundIndex < cv.length){
          if(gameIndex < cv[roundIndex].Games.length){
            return cv[roundIndex].Games[gameIndex].Order;
          }
        }
      }else if(columnType === 'Score'){
        if(roundIndex < cv.length){
          if(gameIndex < cv[roundIndex].Games.length){
            return cv[roundIndex].Games[gameIndex].Score;
          }
        }
      }else if(columnType === 'Sum'){
        let sum = 0;
        if(Object.prototype.hasOwnProperty.call(cv[roundIndex], 'Games')){
          for(let i = 0; i < cv[roundIndex].Games.length; i++){
            sum += cv[roundIndex].Games[i].Score;
          }
        }
        return sum;
      }
      return "";
    },
    ConnectClassName(/*{row}*/) {
      //console.log(row.Connect);
      // if (! row.Connect) {
      //   return 'disconnect-row';
      // }
      return '';
    },
    ResultClassName(result){
      if(result === 'Win'){
        return '';
      }else if(result === 'Lose'){
        return 'danger';
      }else{
        return 'warning';
      }
    },
    BigScore(index){
      let big = 0;
      if(index < 0){
        return 0;
      }
      if(Object.prototype.hasOwnProperty.call(this.tableData[index], 'Rounds')){
        for(let i = 0; i < this.tableData[index].Rounds.length; i++){
          if(Object.prototype.hasOwnProperty.call(this.tableData[index].Rounds[i], 'Games')){
            for(let k = 0; k < this.tableData[index].Rounds[i].Games.length; k++){
              big += this.tableData[index].Rounds[i].Games[k].Score;
            }
          }
        }
      }
      return big;
    },
    SmallScore(index){
      let small = 0;
      if(Object.prototype.hasOwnProperty.call(this.tableData[index], 'Rounds')){
        for(let i = 0; i < this.tableData[index].Rounds.length; i++){
          if(Object.prototype.hasOwnProperty.call(this.tableData[index].Rounds[i], 'Opponents')){
            for(let j = 0; j < this.tableData[index].Rounds[i].Opponents.length; j++){
              small += this.BigScore(this.tableData[index].Rounds[i].Opponents[j].ID-1);
            }
          }
        }
      }
      return small;
    },
    Rank(arr){
      const sorted = arr.slice().sort((a, b) => b - a);
      const rank = arr.map(function(x){ return sorted.indexOf(x)+1 });
      return rank;
    },
    ClickModifyResult(row){
      console.log(row);
      console.log(row.row);
      console.log(row.row.ID);
      console.log(row.column.title);
      console.log(row.column.className);
      if(row.column.className != null){
        if(row.column.className.includes("Result") || row.column.className.includes("Score")){
          let label = row.column.className.split('_')[0];
          let roundIndex = parseInt(row.column.className.split('_')[1]);
          let gameIndex = parseInt(row.column.className.split('_')[2]);
          console.log("label",label,"ID",row.row.ID,"roundIndex",roundIndex,"gameIndex",gameIndex);
          this.ModifyResult(row.row.ID, roundIndex, gameIndex);
        }
      }
    }
  },
  watch: {
    CalculatedData: function(table) {
      console.log(table);
      let index = 0;
      for(let i = 1; i <= table.length; i++){
        for(let j = 0; j < table.length; j++){
          if(table[j].Rank == i){
            if(this.syncRank.length <= index){
              this.syncRank.push(table[j].ID);
            }else{
              this.syncRank[index] = table[j].ID;
            }
            index++;
          }
        }
      }
      //console.log(this.syncRank);
    }
  }
}
</script>
